import { render } from "./RenewGoodsRefund.vue?vue&type=template&id=ed135c1e&scoped=true"
import script from "./RenewGoodsRefund.vue?vue&type=script&lang=js"
export * from "./RenewGoodsRefund.vue?vue&type=script&lang=js"

import "./RenewGoodsRefund.vue?vue&type=style&index=0&id=ed135c1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed135c1e"]])

export default __exports__